import { connect } from 'react-redux';
import { t } from '../../../../../modules/infra/i18n';
import Notes from './Notes';
import { getCustomerNotes } from '../../appointmentSelector';
import { setCustomerNotes } from '../../actions';

const mapStateToProps = state => ({
  value: getCustomerNotes(state),
  title: t('appointment:form.client_notes_title'),
});

const mapDispatchToProps = {
  onChange: setCustomerNotes,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notes);

